export const Splash: React.FC = () => {
    return (
        <div className="splash-container">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 134 50" xmlSpace="preserve" width="200">
                <path transform="translate(74.948 6)" fill="#FFFFFF" d="M18.3,13.8c1.1,0,1.9-0.5,2.5-1.2c0.6,0.7,1.6,1.2,2.5,1.2
	c1.9,0,3.4-1.6,3.4-3.4S25.3,7,23.4,7c-1.1,0-1.9,0.5-2.5,1.2C20.3,7.5,19.4,7,18.4,7C16.5,7,15,8.5,15,10.4S16.4,13.8,18.3,13.8
	 M37.7,13.8c1.9,0,3.4-1.6,3.4-3.4S39.6,7,37.7,7c-1.9,0-3.4,1.6-3.4,3.4S35.8,13.8,37.7,13.8 M5.3,13.8c1.9,0,3.4-1.6,3.4-3.4
	S7.2,7,5.3,7s-3.4,1.6-3.4,3.4S3.4,13.8,5.3,13.8 M31.9,17.2h-5.5c-0.3,0-0.7,0.3-0.7,0.7v1.6H15.5V18c0-0.3-0.3-0.7-0.7-0.7H9.3
	c-0.3,0-0.7,0.3-0.7,0.7v5c0,0.6-0.5,1.2-1.2,1.2H3c-0.6,0-1.2-0.5-1.2-1.2v-5c0-0.3-0.3-0.7-0.7-0.7h-5.3C-4.6,17.2-5,17.5-5,18v5
	c0,4.4,3.6,8,8,8h4.5c3.2,0,6-1.9,7.2-4.5H28c0.6,0,1.2-0.5,1.2-1.2c0,0.6,0.5,1.2,1.2,1.2h11.8c0.3,0,0.7-0.3,0.7-0.7V20
	c0-0.3-0.3-0.7-0.7-0.7h-9.5v-1.6C32.6,17.5,32.2,17.2,31.9,17.2 M45.1,7.7v5.5c0,0.3,0.3,0.7,0.7,0.7h12.2c0.3,0,0.7-0.3,0.7-0.7
	V7.7c0-0.3-0.3-0.7-0.7-0.7H45.8C45.5,7,45.1,7.3,45.1,7.7 M48.5,25.6v-8.8c0-0.3,0.3-0.7,0.7-0.7h5.5c0.3,0,0.7,0.3,0.7,0.7v8.8
	c0,0.3-0.3,0.7-0.7,0.7h-5.5C48.8,26.3,48.5,25.9,48.5,25.6"/>
                <g className="bounce">
                    <path fill="#A3244C" d="M19.5,25.6c0-3.8,3.1-6.9,6.9-6.9s6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9S19.5,29.3,19.5,25.6z" className="dot-3" />
                    <path fill="#C92659" d="M35,25.6c0-3.8,3.1-6.9,6.9-6.9s6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9S35,29.3,35,25.6z" className="dot-2" />
                    <path fill="#F02867" d="M50.4,25.6c0-3.8,3.1-6.9,6.9-6.9c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9C53.5,32.4,50.4,29.3,50.4,25.6z" className="dot-1" />
                </g>
            </svg>
        </div>
    );

};